module.exports = __webpack_public_path__ + "static/logo-mind-d55fa1581c2b2d4068ff8cf935ee3705.png";